export class SchoolDiscountCodeModel {
  amount_off: 9.99
  duration: "forever"
  duration_in_months: null
  name: "9.99 off"
  percent_off: null
}
